import React from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import { handBookActions } from "pages/HandBook/model/slice";

import { useTypedSelector } from "app/store/typedUseSelector";
import SettingsFilterPopup from "shared/ui/controls/SettingsFilterPopup/SettingsFilterPopup";

import { useUrlModuleWithObjectId } from "utils/hooks/useUrlModuleWithObjectId";

const HandBookViewToggle: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const routePrefix = useUrlModuleWithObjectId();
  const templateViewFilters = useTypedSelector((state) => state.handBookReducer.templateViewFilters);
  const { sectionId, templateId } = useParams<{ sectionId: string; templateId?: string }>();
  const allSegments = useTypedSelector((state) => state.handBookReducer.allSegments);
  const isEditingTemplates = useTypedSelector((state) => state.handBookReducer.templateEditings.isEditing);

  const toggleViewMode = (isAttributes: boolean) => {
    dispatch(handBookActions.setTemplateViewFilter({ attribute: isAttributes }));

    // Редирект на корень текущего шаблона, если мы находимся внутри раздела
    if (sectionId) {
      if (templateId) {
        history.push(`/${routePrefix}/handbook/templates/${templateId}`);
      } else {
        history.push(`/${routePrefix}/handbook/templates`);
      }
    }
  };

  const onChangeFilter = (filter: keyof typeof templateViewFilters) => (value: boolean) => {
    dispatch(handBookActions.setTemplateViewFilter({ [filter]: value }));
  };
  // material, equipment, machine, transport
  return (
    <SettingsFilterPopup
      filters={
        [
          {
            label: "Показать материалы",
            value: Boolean(templateViewFilters.material),
            onChange: onChangeFilter("material"),
          },
          {
            label: "Показать оборудование",
            value: Boolean(templateViewFilters.equipment),
            onChange: onChangeFilter("equipment"),
          },
          {
            label: "Показать машины",
            value: Boolean(templateViewFilters.machine),
            onChange: onChangeFilter("machine"),
          },
          {
            label: "Показать транспорт",
            value: Boolean(templateViewFilters.transport),
            onChange: onChangeFilter("transport"),
          },
          // Скрываем переключение по атрибутам, если их нет или если редактируем структуру
          allSegments?.length > 0 &&
            !isEditingTemplates && {
              label: "По атрибутам",
              value: Boolean(templateViewFilters.attribute),
              // Отдельно обрабатывам атрибуты из-за редиректа
              onChange: (value: boolean) => toggleViewMode(value),
            },
        ].filter((x) => x) as any[]
      }
    />
  );
};

export default HandBookViewToggle;
